import { profilePhotosDeleteSelectedImageButton } from '@/components/ProfileData/styles.ts';

interface DeleteButtonProps {
  handleDelete: () => void;
}

const DeleteButton = ({ handleDelete }: DeleteButtonProps) => {
  return (
    <button
      type="button"
      onClick={handleDelete}
      style={profilePhotosDeleteSelectedImageButton}
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 4L4 12M4 4L12 12"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </button>
  );
};

export default DeleteButton;
